// extracted by mini-css-extract-plugin
export default {"link":"style_link__nNLPQ","active":"style_active__OI9DP","line":"style_line__eiu8C","title":"style_title__UYunT","desc":"style_desc__NUzoa"};